<div class="page about-us">
	<div class="illustrated-item" id="entrada1">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">¿Quiénes somos?</p>
			<p>Somos una asociación que trabaja de forma
				grupal la socialización y el cambio en la población reclusa más
				sensible, durante o después del cumplimiento de la pena, añadiendo
				la acogida como elemento de reinserción.</p>
			<p>Constituimos una entidad privada sin fines
				lucrativos, que surge a partir de la iniciativa ciudadana para el
				beneficio de la comunidad. Somos, por tanto, independientes de la
				administración pública.</p>
		</div>
	</div>
	<div class="illustrated-item" id="entrada2">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">Recursos</p>
			<p>En cuanto a equipamiento, contamos con seis
				pisos de acogida, en régimen de alquiler, propiedad del IVIMA,
				además de un almacén y vehículos para el transporte, tanto de
				personas como de mercancías.</p>
			<p>Por otro lado, en lo referente a la
				financiación, recurrimos a subvenciones públicas: administraciones
				municipales, autonómicas y nacionales; así como a subvenciones
				privadas. Además, contamos con la inestimable ayuda de colectas
				parroquiales y donativos particulares.</p>
		</div>
	</div>
	<div *ngIf="false" class="illustrated-item" id="entrada3">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">Organigrama</p>
			<p>
				<strong>Ángeles Pérez Guerrero</strong><br /> Presidenta: dirección
				del proyecto.
			</p>
			<p>
				<strong>Ramón Merino Enseñat</strong><br /> Vicepresidente:
				aprobación de las cuentas.
			</p>
			<p>
				<strong>Fernando del Val Torregrosa</strong><br /> Secretario y
				tesorero: administración, gestión de los bienes.
			</p>
			<p>
				<strong>Ingrid Muñoz Rubio</strong><br /> Psicóloga: terapia
				individual y grupal, organización de actividades.
			</p>
			<p>
				<strong>Basilio Manuel Fernández Franco</strong><br /> Educador:
				apoyo educativo y burocrático.
			</p>
			<p>
				<strong>Ramón de la Rosa Moreno</strong><br /> Monitor: cuidado y
				vigilancia de los pisos de acogida.
			</p>
			<p>
				<strong>Raquel Barrios</strong><br /> Monitora: cuidado y vigilancia
				de los pisos de acogida.
			</p>
		</div>
	</div>
	<div class="illustrated-item" id="entrada4">
		<div class="illustration"></div>
		<div class="content">
			<p class="title">Misión y visión</p>
			<p>Nuestra misión es contrarrestar las carencias
				de los centros penitenciarios en materia de reinserción social, como
				precepto que es de los mismos, a través de la intervención social,
				haciéndolo con notoriedad para justificar las ayudas institucionales
				y privadas.</p>
			<p>Esta misión corresponde a la visión de nuestra
				entidad, que expresa su convicción sobre la capacidad de los
				reclusos de formarse en el desarrollo de la conciencia y en el
				respeto a la vida, a través de la actividad educativa y terapéutica,
				tanto individual como comunitaria, como pasarela a la sociedad.</p>
		</div>
	</div>
</div>